import * as React from "react";
import {BrowserRouter as Router, Route, Switch, Link, useRouteMatch} from "react-router-dom"
import {groupBy, isEmpty} from "lodash";

import {HelpArticle, HelpTopic, HelpType} from "../../apis/orders/models/help_pb";
import {Lookup} from "../../apis/orders/models/catalog_pb";
const {useEffect, useState, Fragment} = React

interface HelpContext {
    helpTopics: Array<HelpTopic.AsObject>
    helpTypes: Array<Lookup.AsObject>
    helpArticle?: HelpArticle.AsObject
}
declare let helpContext: HelpContext

function TopicListItem({helpTopic}:{helpTopic: HelpTopic.AsObject}){
    return <a className={`font-medium text-strong-orange hover:underline py-2 ${helpTopic.active ? "": "bg-yellow"}`} href={`/faqs/${helpTopic.id}`}>
        {helpTopic.topic}
    </a>
}
interface HelpTypeCardProps {
    helpTypes: Array<Lookup.AsObject>
    helpTopics: Array<HelpTopic.AsObject>}
function HelpTypeCard({helpTypes, helpTopics}:HelpTypeCardProps){
    const [helpType, setHelpType] = useState<Lookup.AsObject | null>(null)
    const [showContent, setShowContent] = useState(false)

    useEffect(() => {

        if(!isEmpty(helpTypes) && !isEmpty(helpTopics)){
            const type = helpTypes.find(helpType => helpType.code === helpTopics[0].helpTypeCode)
            if(type !== undefined){
                setHelpType(type)
            }
        }
    },[helpTypes, helpTopics])
    return <div className="bg-white p-4 lg:px-6 rounded-md shadow-md mb-4">
        <div className="flex justify-between items-center mb-2">
            <h4 className="text-black text-lg">{helpType && helpType.name}</h4>
            <span className="cursor-pointer text-strong-orange hover:underline" onClick={() => setShowContent(!showContent)}>{showContent ? "close": "open"}</span>
        </div>
        {showContent && <div className="flex flex-col">
            {!isEmpty(helpTopics) ? helpTopics.map((helpTopic, key) => <Fragment key={key}>
                <TopicListItem helpTopic={helpTopic} />
                <hr className='bg-black w-full px-4'/>
            </Fragment>): <span>no topics under this help type</span>}
        </div>
        }
    </div>
}

function FAQPage(){
    if(!helpContext.helpArticle.content){
        return null
    }

    return <div className="p-4 lg:p-6 bg-white">
        <h5 className="text-2xl mb-6">{helpContext.helpArticle.topic}</h5>
        <div className="mb-4 text-sm">
            {helpContext.helpArticle.content}
        </div>
    </div>
}

export default function App(){
    const [topics] = useState<Record<string,HelpTopic.AsObject[]>>(groupBy(helpContext.helpTopics, 'helpTypeCode'))
    const [helpTypes] = useState<Lookup.AsObject[]>(helpContext.helpTypes)

    return <Router>
        <Route>
            <div className="w-full h-full flex items-center overflow-x-hidden">
                <div className="w-3/12 h-full bg-bright-red flex flex-col px-4 lg:px-6 pt-8 text-white overflow-x-hidden overflow-y-scroll">
                    <img className="w-48 h-auto mb-6" src="/assets/img/zulzi-logo.svg" alt=""/>
                    <h4 className=" font-bold text-3xl">FAQs</h4>
                    <span className="text-lg">Click on a title to navigate to that section</span>
                    <div>
                        {!isEmpty(Object.keys(topics)) && Object.keys(topics).map((key, idx) => <HelpTypeCard helpTypes={helpTypes} helpTopics={topics[key]} key={idx}/>)}
                    </div>
                </div>
                <div className="w-9/12 h-full bg-white overflow-scroll">
                    <Switch>
                        <Route exact path='/faqs'>
                            <div className="px-4 lg:px-6">
                                <p className="text-black">Click on a title to navigate to that section</p>
                            </div>
                        </Route>
                        <Route path="/faqs/:faqId">
                            <FAQPage/>
                        </Route>
                    </Switch>
                </div>
            </div>
        </Route>
    </Router>
}